import { Category as Component } from './component';
import { enhance } from './enhancers';

export const Category = enhance(Component);
